// @flow
import 'react-tippy/dist/tippy.css'
import React, { Component, Fragment } from 'react'
import { Tooltip as ReactTippy } from 'react-tippy'
import type { Node as ReactNode } from 'react'
import { createGlobalStyle } from 'styled-components'

type Position =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'top-start'
  | 'bottom-start'
  | 'left-start'
  | 'right-start'
  | 'top-end'
  | 'bottom-end'
  | 'left-end'
  | 'right-end'

type Props = {|
  content: ReactNode,
  children?: ReactNode,
  distance?: number,
  isOpen?: boolean,
  isDisabled?: boolean,
  position?: Position,
  className?: string,
  hasStrongShadow?: boolean,
  isInteractive?: boolean,
  isTriggeredByClick?: boolean,
  hideArrow?: boolean,
  onShow?: () => void,
  onHide?: () => void,
  onClose?: () => void
|}

const GlobalStyle = createGlobalStyle`
  .tippy-tooltip.strong-shadow-theme.priority-theme {
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.4);
  }
`

export default class Tooltip extends Component<Props> {
  render() {
    const { content, hasStrongShadow, onClose, onShow, onHide } = this.props

    return (
      <Fragment>
        <GlobalStyle />
        <ReactTippy
          theme={`light${hasStrongShadow ? ' strong-shadow priority' : ''}`}
          arrow={!this.props.hideArrow}
          duration={0}
          open={this.props.isOpen}
          distance={this.props.distance}
          disabled={this.props.isDisabled}
          position={this.props.position || 'bottom'}
          className={this.props.className}
          interactive={this.props.isInteractive}
          interactiveBorder={5}
          trigger={
            this.props.isTriggeredByClick
              ? 'click'
              : typeof this.props.isOpen === 'boolean'
              ? 'manual'
              : void 0
          }
          {...(typeof content === 'string' ? { title: content } : { html: content })}
          onRequestClose={() => onClose && onClose()}
          onShow={() => onShow && onShow()}
          onHidden={() => onHide && onHide()}
        >
          {this.props.children}
        </ReactTippy>
      </Fragment>
    )
  }
}
